import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { resetApplication } from '../../store/applicationActions';
import { IApplicationState } from '../../store/applicationState';
import { fetchGroups } from '../../store/group/groupActions';
import { IGroup, IMember } from '../../store/group/groupState';
import { getCurrentUser } from '../../store/person/personActions';
import userManager from '../../userManager';
import Icon from '../shared/icon/Icon';

interface IOwnProps {
    logoutCallBack: () => void;
}

interface IStateProps {
    currentGroup?: string;
    groups: IGroup[];
    user: any;
    member?: IMember;
    viewerIsDi: boolean | null;
}

interface IDispatchProps {
    fetchGroups: typeof fetchGroups;
    getCurrentUser: typeof getCurrentUser;
    resetApplication: typeof resetApplication;
}

type Props = IOwnProps & IStateProps & IDispatchProps;

interface IState {
    showMenu: boolean;
    isGroupsLoaded: boolean;
    previousGroup?: string;
}

class Header extends React.Component<Props, IState> {
    private toggler = React.createRef<HTMLAnchorElement>();

    constructor(props: Props) {
        super(props);

        this.state = {
            showMenu: false,
            isGroupsLoaded: false,
            previousGroup: undefined
        }
    }

    public async componentDidMount() {
        document.addEventListener('click', this.closeMenu);

        const promises: any[] = [this.props.getCurrentUser()];
        const isDi = this.props.viewerIsDi as boolean;

        if (!this.state.isGroupsLoaded && isDi !== null) {
            promises.push(this.props.fetchGroups(isDi));

            this.setState({
                isGroupsLoaded: true
            });
        }

        await Promise.all(promises);
    }

    public componentDidUpdate() {
        const isDi = this.props.viewerIsDi as boolean;

        if (!this.state.isGroupsLoaded && isDi !== null) {
            this.props.fetchGroups(isDi);

            this.setState({
                isGroupsLoaded: true
            });
        }
    }

    public componentWillUnmount() {
        document.removeEventListener('click', this.closeMenu);
    }

    public render() {
        return <header className="main-header main-header--bordered w--lg">
            <div className="main-header__inner flex-grid">
                <div className="flex-grid__col flex-grid__col--3 flex-grid__col--md-4 flex-grid__col--lg-3">
                    <Link className="button button--logo theme--local theme-didk2023" to={this.groupPageUrl()} aria-label="DInet start">
                        {this.logo()}
                        <span className="text text--headline">Dansk Industri</span>
                    </Link>
                </div>
                <div className="flex-grid__col flex-grid__col--6 flex-grid__col--md-4 flex-grid__col--lg-6">
                    <div className="main-header__caption">
                        <Link to={this.groupPageUrl()}>
                            {this.groupTitle()}
                        </Link>
                    </div>
                </div>
                <div className="flex-grid__col flex-grid__col--3 flex-grid__col--md-4 flex-grid__col--lg-3">
                    {this.props.user &&
                        <div className="authorized-menu">
                            <span id="test" className="authorized-menu__toggle pointer" ref={this.toggler} onClick={this.toggleMenu} title={this.props.user.profile.email}>
                                {this.profileImage()}
                                <div className="authorized-menu__toggle__name">{this.props.user.profile.given_name.split(' ')[0]}</div>
                            </span>
                            {this.state.showMenu &&
                                <div className="authorized-menu__popup is-active">
                                    {this.props.groups.length > 0 &&
                                        <ul className="authorized-menu__list">
                                            {this.props.groups.map((group, index) => {
                                                return <li className="authorized-menu__list__item" key={index}>
                                                    <Link className="button has-icon" to={`/Group/${group.reference}`}>
                                                        <span className="icon">
                                                            {group.icon
                                                                ? <img src={group.icon} alt={group.name} />
                                                                : <Icon name="netvaerk" />}
                                                        </span>
                                                        {group.name}
                                                    </Link>
                                                </li>;
                                            })}
                                        </ul>
                                    }
                                    {this.props.user && this.props.viewerIsDi &&
                                        <ul className="authorized-menu__list">
                                            <li className="authorized-menu__list__item">
                                                <Link className="button" to={`/Tools/UpcommingMeetings`}>Kommende møder</Link>
                                            </li>
                                        </ul>
                                    }
                                    {this.props.user && this.props.user.profile &&
                                        <ul className="authorized-menu__list">
                                            <li className="authorized-menu__list__item">
                                                <Link className="button" to={`/Profile/${this.props.user.profile.Id}`}>Mine oplysninger</Link>
                                            </li>
                                            <li className="authorized-menu__list__item">
                                                <a href="/#" className="button" onClick={this.logOut}>Log ud</a>
                                            </li>
                                        </ul>}
                                </div>
                            }
                        </div>
                    }
                </div>
            </div>
        </header>;
    }

    private logo() {
        const group = this.currentGroup();

        if (group && group.icon) {
            return <img src={group.icon} alt={group.name} />;
        }

        return <Icon name="logo" isV2={true} />;
    }

    private groupPageUrl() {
        const group = this.currentGroup();

        if (group) {
            return `/Group/${group.reference}`;
        }

        return '/';
    }

    private groupTitle() {
        const group = this.currentGroup();

        if (group) {
            return group.name;
        }

        return null;
    }

    private currentGroup() {
        if (this.props.currentGroup && this.props.groups && this.props.groups.length) {
            const group = this.props.groups.filter(g => g.id.toString() === this.props.currentGroup || g.alias === this.props.currentGroup);

            if (group && group.length) {
                return group[0];
            }
        }

        return null;
    }

    private profileImage() {
        if (this.props.member && this.props.member.imageUrl) {
            return <div className="authorized-menu__toggle__image" style={{ backgroundImage: `url(${this.props.member.imageUrl})` }} />;
        }

        return <div className="authorized-menu__toggle__image"><Icon name="profile" /></div>;
    }

    private toggleMenu = (e: React.MouseEvent<HTMLElement>) => {
        e.preventDefault();

        this.setState(prevState => ({
            showMenu: !prevState.showMenu
        }));
    }

    private closeMenu = (e: MouseEvent) => {
        if (this.state.showMenu && !(this.toggler.current && (this.toggler.current === e.target || this.toggler.current!.contains(e.target as HTMLElement)))) {
            this.setState(() => ({
                showMenu: false
            }));
        }
    }

    private logOut = async (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();

        this.props.logoutCallBack();

        await (await userManager).signoutRedirect();

        this.props.resetApplication();
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => ({
    currentGroup: state.groupData.currentGroup,
    groups: state.groupData.groups.groups.allIds.map((id) => state.groupData.groups.groups.byId[id]),
    member: state.person.currentUser,
    user: state.oidc.user,
    viewerIsDi: state.oidc.user && state.oidc.user.profile ? state.oidc.user.profile.role === 'DI' : null
});

const mapDispatchToProps = (dispatch: any): IDispatchProps => ({
    fetchGroups: (isDi: boolean) => dispatch(fetchGroups(isDi)),
    getCurrentUser: () => dispatch(getCurrentUser()),
    resetApplication: () => dispatch(resetApplication())
});

const container = connect(mapStateToProps, mapDispatchToProps)(Header);

export default container;